define('home/views/formatting/LinkPopoverView',[
    'jquery',
    'underscore',

    'core/utils',

    'home/templates/linkInsertTooltip',
    'home/views/BasePopoverView',
], function (
    $,
    _,

    utils,

    linkInsertTooltipTemplate,
    BasePopoverView
) {
    'use strict';

    var handler = utils.preventDefaultHandler;

    var parent = BasePopoverView;
    var parentProto = parent.prototype;

    var InsertLinkPopoverView = parent.extend({
        events: {
            'blur input': 'saveModel',
            'submit [data-role=link-form]': 'insertLink',
        },

        template: linkInsertTooltipTemplate,

        initialize: function () {
            parentProto.initialize.apply(this, arguments);

            // Listen for changes to the form model
            // This must be done per-field to avoid clearing any
            // validation errors which were added to the form
            this.listenTo(this.model, {
                'change:text': function (_model, text) {
                    this.$('[name=text]').val(text);
                },
                'change:url': function (_model, url) {
                    this.$('[name=url]').val(url);
                },
            });

            this._open = false;

            this.onBodyClick = _.bind(this.onBodyClick, this);
        },

        render: function () {
            this.$el.html(this.template(this.model.toJSON()));

            return this;
        },

        remove: function () {
            this.removeBodyEvent();

            parentProto.remove.apply(this, arguments);
        },

        attachBodyEvent: function () {
            $('body').on('click', this.onBodyClick);
        },

        removeBodyEvent: function () {
            $('body').off('click', this.onBodyClick);
        },

        show: function () {
            // Set up a delay to focus the first form field after rendering
            // FIXME: It's not clear why this must be delayed. If the focus
            // call is immediately after rendering (via .show), or even
            // after rendering by a small delay (ex. 10ms), it will not
            // focus the input element. The delay chosen here (50ms) is
            // arbitrary but appears to consistently work.
            _.delay(_.bind(function () {
                this.$('input').eq(0).focus();
            }, this), 50);

            // Avoid re-rendering if already open to prevent loss of user input
            if (this._open)
                return;

            this._open = true;

            this.attachBodyEvent();

            parentProto.show.apply(this, arguments);
        },

        hide: function () {
            parentProto.hide.apply(this, arguments);

            // FIXME: This is to avoid the hide event forcing the selection when the popover
            // is already closed, but this is really a concern of the containing view; the
            // event needs to be re-examined
            if (!this._open)
                return;

            this._open = false;

            this.removeBodyEvent();

            this.saveModel();

            this.trigger('hide');
        },

        saveModel: function () {
            this.model.set({
                url: this.$('[name=url]').val().trim(),
                // Do not trim text, as surrounding whitespace may be significant
                // (depending on initial user selection)
                text: this.$('[name=text]').val(),
            });
        },

        insertLink: handler(function () {
            // Update model from form values again; if user uses
            // keyboard enter to submit form, there will not be
            // a blur event to trigger a model save
            this.saveModel();

            if (this.model.isValid())
                this.trigger('submit', this.model.toJSON());
            else
                this.displayError(this.model.validationError);
        }),

        displayError: function (error) {
            // Remove any existing error first
            this.$('.form-attribute-input').removeClass('is-error');

            this.$('[data-attribute=' + error.attrName + ']')
                .addClass('is-error')
                .find('[data-role=attribute-error]')
                .text(error.message);
        },
    });

    return InsertLinkPopoverView;
});

